<app-authentication-codeverification [email]="email$ | async" [showMessage]="this.isPasswordSend$ | async"
    (setVerificationClicked)="onSetVerification($event)" (goBackClicked)="onGoBack()"
    (resendCodeClicked)="resendCodeClicked($event)">
</app-authentication-codeverification>